import { FileTrigger } from 'components/FileTrigger/FileTrigger'
import { ButtonProps } from 'blaze-ui/Button/Types'
import { Edit1 } from 'blaze-ui/icons'
import { IconButton } from 'blaze-ui/IconButton/IconButton'

interface ReplaceButtonProps extends Pick<ButtonProps, 'isDisabled'> {
  onReplace: (file: File) => void
  editTrigger?: React.ReactNode
}

export const ReplaceButton = ({ onReplace, isDisabled, editTrigger }: ReplaceButtonProps) => (
  <FileTrigger
    accept={['image/*']}
    allowsMultiple={false}
    onSelect={async (files) => {
      if (files && files.length > 0) {
        onReplace(files[0])
      }
    }}
  >
    {editTrigger || (
      <IconButton size="sm" variant="secondary" icon={Edit1} isDisabled={isDisabled} aria-label="Replace" />
    )}
  </FileTrigger>
)
